import React from 'react';
import {t} from 'i18next';
import {PageAPI, PageDetectionActionType} from '@taopix/taopix-core';
import {PageInterface, ReducerState, ShuffleLayoutArgs} from '@taopix/taopix-core/dist/types/types';
import {TaopixContextState} from '../../Components/Context/TaopixContext';

const isLayoutApplied = (
  page: PageInterface,
  ref: number,
  detectionArea: PageDetectionActionType
) => {
  // create a map of the applied styles & their detection area
  const appliedRefs = {
    [PageDetectionActionType.CurrentLeft]: page.leftpagestyleref,
    [PageDetectionActionType.CurrentRight]: page.rightpagestyleref,
    [PageDetectionActionType.CurrentSpread]: page.leftpagestyleref,
  };

  // if the current applied ref matches the requested ref, return true
  if (Number(appliedRefs[detectionArea]) === Number(ref)) {
    return true;
  }
  return false;
};

export const onSetLayout = (
  app: TaopixContextState,
  payload: ShuffleLayoutArgs,
  detectionArea: PageDetectionActionType,
  api: PageAPI,
  notifier: React.Dispatch<React.SetStateAction<string>>
) => {
  const stateManager = app.core.get('stateManager');
  const page = stateManager.getPage(api.getPageNumber());
  stateManager
    .call<ShuffleLayoutArgs, ReducerState & {ref: number}>('shuffleLayout', payload)
    .then(({ref}) => {
      if (-1 === ref || isLayoutApplied(page, ref, detectionArea)) {
        notifier(t('str_LabelNoLayoutsAvailable'));
        return void 0;
      }
      app.core.dispatch('PAGE.APPLY_PAGE_STYLE', {
        pageNumber: payload.pageNumber,
        ref: String(ref),
        detectionArea: detectionArea,
      });
    });
};
